import * as Common from '@/tenantCatalog/common';

export class Subscription extends Common.ObjectBase{
  constructor(){
    super('Subscription')
  }
public tenantId :string = '';
public tenant : Common.Tenant;
public licenseFlag : number;
public licenseCount:number;
public storageSize:number;
public periodFrom :Date;
public periodTo : Date;

}

export class SubscriptionQuery extends Common.LoadQuery {
  constructor(){
    super('SubscriptionQuery',Subscription);
    this.sort = 'tenantId';    
  }
  public tenantId :string = '';
  public tenantName :string = '';
}